module.exports = __webpack_public_path__ + "img/icon_link.72a267dc.png";